import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * NotFound — rendered for any URL that does not match a defined route.
 * Placement: add as the last <Route path="*"> in App.js MainContent.
 * Fixes: WCAG 2.4.2 (page title), blank page on unknown URLs.
 */
function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found — Our Broking';
    return () => { document.title = 'Our Broking'; };
  }, []);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem 1.5rem',
        textAlign: 'center',
        fontFamily: 'sans-serif',
      }}
    >
      <p
        style={{
          fontSize: '5rem',
          fontWeight: 800,
          color: '#f59e0b',
          lineHeight: 1,
          margin: '0 0 1rem',
        }}
        aria-hidden="true"
      >
        404
      </p>
      <h1 style={{ fontSize: '1.75rem', color: '#0f172a', margin: '0 0 0.75rem' }}>
        Page not found
      </h1>
      <p style={{ color: '#475569', maxWidth: '34rem', margin: '0 0 2rem', lineHeight: 1.7 }}>
        The page you are looking for does not exist or may have moved.
        Please check the URL or return to the homepage.
      </p>
      <Link
        to="/"
        style={{
          padding: '0.8rem 1.75rem',
          background: '#f59e0b',
          color: '#0f172a',
          borderRadius: '999px',
          fontWeight: 700,
          textDecoration: 'none',
        }}
      >
        Go to Homepage
      </Link>
    </div>
  );
}

export default NotFound;